import React from 'react';
import { t } from 'react-switch-lang';
import Hero from './Hero';
import Features from './Features';
import { DocumentTitle } from '../../../helperFunctions/DocumentTitle';

function MyeCash() {
  DocumentTitle(t('DocTitle_MyeCash'));

  return (
    <>
      <Hero />
      <Features />
    </>
  );
}

export default MyeCash;
